export const OFFICE_DOMAIN = 'https://lofty.com'

export const REGION_SHOW_MLS = true



